<template>
  <picture v-if="media.img">
    <!--    [{{ image.title }} | {{ img.src }} | {{ foo.img.src }}]-->

    <source
      v-for="imageSource in media.sources"
      :key="`${imageSource.media}:${imageSource.src}`"
      :media="imageSource.media"
      :width="imageSource.width"
      :height="imageSource.height"
      :srcset="imageSource.src"
    />

    <img
      :width="media.img.width"
      :height="media.img.height"
      :src="media.img.src"
      :alt="alt !== undefined ? alt : image?.title || source"
      :role="role"
      :aria-hidden="ariaHidden === true ? 'true' : ariaHidden === false ? 'false' : undefined"
      :loading="lazy ? 'lazy' : 'eager'"
      class="block w-full h-full object-cover"
      :class="imgClass"
    />
  </picture>
</template>

<script setup lang="ts">
import { getMediaImage } from '~/assets/media'

const props = defineProps({
  image: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  alt: { type: String, required: false, default: undefined },
  imgClass: { type: String, required: false, default: '' },
  lazy: { type: Boolean, required: false, default: true },
  role: { type: String, required: false, default: undefined },
  ariaHidden: { type: Boolean, required: false, default: undefined },
})

const media = computed(() => {
  return getMediaImage(props.image)
})

const source = props.image?.source
</script>

<style lang="scss" scoped>
.skeleton {
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: -150px;
    top: 0;
    height: 100%;
    width: 150px;
    background: linear-gradient(to right, transparent 0%, #e8e8e8 50%, transparent 100%);
    animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }

  @keyframes load {
    from {
      left: -150px;
    }
    to {
      left: 100%;
    }
  }
}
</style>
